var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminPortalPoster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .b, .c, .d {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .e {\n        fill: #fff;\n      }\n\n      .f {\n        fill: #6f3d90;\n      }\n\n      .c {\n        stroke-dasharray: .88 2.63;\n        stroke-width: 1.75px;\n      }\n\n      .d {\n        stroke-width: 2px;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 112.67,
    y: 152.59,
    width: 75.02,
    height: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 150,
    cy: 148.89,
    r: 120
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 119.74,
    y: 99.09,
    width: 87.36,
    height: 106.66
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 119.74,
    y1: 192.97,
    x2: 102.55,
    y2: 192.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 119.74,
    y1: 185.65,
    x2: 102.55,
    y2: 185.65
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 119.74,
    y1: 119.18,
    x2: 102.55,
    y2: 119.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 119.74,
    y1: 111.86,
    x2: 102.55,
    y2: 111.86
  }))), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M101.97,271.11h-9.07V96.66c0-3.07,2.03-5.56,4.53-5.56h0c2.5,0,4.53,2.49,4.53,5.56v174.44Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 134.98,
    y1: 168,
    x2: 191.86,
    y2: 168
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 134.98,
    y1: 144.72,
    x2: 191.86,
    y2: 144.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 134.96,
    y: 185.45,
    width: 56.93,
    height: 1.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 152.47,
    y: 116.79,
    width: 21.89,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 134.96,
    y: 181.11,
    width: 35.03,
    height: 1.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 141.38,
    y: 126.65,
    width: 44.08,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 174.37,
    y: 181.11,
    width: 17.52,
    height: 1.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 134.79,
    y1: 155.98,
    x2: 191.67,
    y2: 155.98
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminPortalPoster);
export default __webpack_public_path__ + "static/media/admin_portal_poster.6460faa2081a1a2fe55ba756bd512fe3.svg";
export { ForwardRef as ReactComponent };